import { ResponsiveLine, Serie, SliceTooltip } from "@nivo/line";
import moment from "moment";
import { min } from "lodash";
import { linearGradientDef } from "@nivo/core";
import useChartTheme from "./chartTheme";

type Props = {
  data: Serie[];
  tooltip: SliceTooltip;
};

export default function Area({ data, tooltip }: Props) {
  const chartTheme = useChartTheme();
  return (
    <ResponsiveLine
      data={data}
      theme={chartTheme}
      margin={{ top: 8, right: 16, bottom: 64, left: 32 }}
      xScale={{
        type: "time",
        format: "%Y-%m-%d",
        useUTC: false,
        precision: "month",
      }}
      xFormat="time:%Y-%m-%d"
      yScale={{
        type: "linear",
        min: 0,
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      curve="linear"
      axisTop={null}
      axisRight={null}
      axisLeft={{
        tickValues: 5,
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendOffset: -40,
        legendPosition: "middle",
      }}
      axisBottom={{
        tickValues: min([6, data[0]?.data.length]),
        format: (d) => {
          return moment(d).format("D/MMM/YY");
        },
      }}
      enablePoints={false}
      enableArea={true}
      areaOpacity={0.8}
      useMesh={true}
      enableSlices="x"
      enableGridY={true}
      enableGridX={false}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: 64,
          itemsSpacing: 20,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 1,
          symbolSize: 12,
          symbolShape: "circle",
        },
      ]}
      sliceTooltip={tooltip}
      colors={{ datum: "color" }}
      defs={[
        linearGradientDef("gradient", [
          { offset: 0, color: "inherit", opacity: 0.4 },
          { offset: 60, color: "inherit", opacity: 0 },
        ]),
      ]}
      // fill={[{ match: "*", id: "gradient" }]}
      gridYValues={5}
    />
  );
}
